import mapOverlayService from "../../services/MapOverlayService";
import MAP_OVERLAYS from "../../constants/mapOverlays";

export const TOGGLE_MAP_OVERLAY = "vendors/TOGGLE_MAP_OVERLAY";
export const GET_MAP_OVERLAYS_SUCCESS = "vendors/GET_MAP_OVERLAYS_SUCCESS";
export const GET_MAP_OVERLAYS_FAIL = "vendors/GET_MAP_OVERLAYS_FAIL";

export function getMapOverlays() {
    return (dispatch) => {
        return mapOverlayService.getMapOverlays
            .then(result => {
                dispatch({type: GET_MAP_OVERLAYS_SUCCESS,
                    mapOverlayOptions: [
                        ...result,
                        {
                            id: 0,
                            displayName: "No Overlay",
                            isSelected: false
                        }
                    ]
                });
                dispatch({type: TOGGLE_MAP_OVERLAY, activeMapOverlayId: MAP_OVERLAYS.NONE});
            })
            .catch(err => dispatch({type: GET_MAP_OVERLAYS_FAIL, err}));
    };
}

export function toggleMapOverlay(activeMapOverlayId) {
    return {type: TOGGLE_MAP_OVERLAY, activeMapOverlayId};
}
